import Button from '../../common/Button/Button';
import styles from './Home.module.scss';
import { useSelector } from 'react-redux';
import { getAllOffers } from '../../../redux/offersRedux';
import { useNavigate } from 'react-router-dom';

// ===================
// pages vievs
// ==================

import AboutUs from '../../vievs/AboutUsHome/AboutUsHome';
import Contact from '../../vievs/Contact/Contact';

const Home = () => {
  const offers = useSelector(getAllOffers);
  const navigate = useNavigate();

  return (
    <div className={styles.home} id='offers'>
      <h1 className={styles.title}> Oferta</h1>
      <p>
        Kompleksowa opieka psychologiczna i terapeutyczna dla dorosłych oraz
        dzieci
      </p>
      <div className={styles.offers}>
        {offers.map((offer) => (
          <div key={offer.id} className={styles.offerBox}>
            <div className={styles.offerHeader}>
              <span>{offer.icon}</span>
              <h3>{offer.title}</h3>
            </div>

            <Button
              key={offer.id}
              onClick={() => navigate(`/offers#offer-${offer.id}`)}
            >
              Dowiedz się więcej
            </Button>
          </div>
        ))}
      </div>
      <AboutUs />
      <Contact />
    </div>
  );
};

export default Home;
